import * as React from 'react'
import { styleguide } from 'styleguide'

export default props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="bar-icon-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="bar-icon-Group-45">
        <g id="bar-icon-Rectangle-9">
          <use id="bar-icon-Mask" fill="#FFFFFF" xlinkHref="#bar-icon-path-1" />
          <g id="bar-icon-Group-42" mask="url(#mask-2)">
            <g transform="translate(18.000000, 16.000000)">
              <g
                id="bar-icon-Group-28"
                transform="translate(0.000000, 14.000000)">
                <rect
                  id="bar-icon-Rectangle-9"
                  fill={styleguide.colors.primary}
                  x="0"
                  y="31.9767442"
                  width="12"
                  height="23.0232558"
                />
                <rect
                  id="bar-icon-Rectangle-9-Copy"
                  fill={styleguide.colors.secondary}
                  x="0"
                  y="0"
                  width="12"
                  height="31.9767442"
                />
              </g>
              <g
                id="bar-icon-Group-27"
                transform="translate(27.000000, 27.000000)">
                <rect
                  id="bar-icon-Rectangle-9-Copy-3"
                  fill={styleguide.colors.secondary}
                  x="0"
                  y="0"
                  width="12"
                  height="26.7272727"
                />
                <rect
                  id="bar-icon-Rectangle-9-Copy-2"
                  fill={styleguide.colors.primary}
                  x="0"
                  y="15.2727273"
                  width="12"
                  height="26.7272727"
                />
              </g>
              <g
                id="bar-icon-Group-27-Copy"
                transform="translate(53.000000, 0.000000)">
                <rect
                  id="bar-icon-Rectangle-9-Copy-3"
                  fill={styleguide.colors.secondary}
                  x="0"
                  y="0"
                  width="12"
                  height="43.4444444"
                />
                <rect
                  id="bar-icon-Rectangle-9-Copy-2"
                  fill={styleguide.colors.primary}
                  x="0"
                  y="25.5555556"
                  width="12"
                  height="43.4444444"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Icon/BarSvg.jsx